import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getClientOptions } from "features/Clients/services/ClientService";
import type { SelectOption } from "types/api.types";
import { getEnquiryOptions } from "features/Enquiries/services/EnquiryService";
import type { EnquirySelectOption } from "features/Enquiries/types/enquiry.types";
import {
  EnquiryOption,
  EnquirySingleValue,
} from "features/Enquiries/components/EnquirySelectComponents";
import {
  EnquirySiteVisitStatus,
  EnquirySiteVisitStatusMap,
} from "features/EnquirySiteVisits/constants/enquiry-site-visit.constants";

const LIST_STATUSES = Object.values(EnquirySiteVisitStatus);

export type EnquirySiteVisitListFiltersProps = {
  selectedStatuses: EnquirySiteVisitStatus[];
  onToggleStatus: (s: EnquirySiteVisitStatus, checked: boolean) => void;
  enquiryId: number | null;
  onEnquiryIdChange: (v: number | null) => void;
  clientId: number | null;
  onClientIdChange: (v: number | null) => void;
};

export default function EnquirySiteVisitListFilters({
  selectedStatuses,
  onToggleStatus,
  enquiryId,
  onEnquiryIdChange,
  clientId,
  onClientIdChange,
}: EnquirySiteVisitListFiltersProps) {
  return (
    <div className="d-flex flex-column gap-3 w-100">
      <div>
        <Label className="form-label text-muted small mb-2 d-block">
          Status
        </Label>
        <div className="d-flex flex-wrap gap-3">
          {LIST_STATUSES.map((st) => (
            <FormGroup check className="mb-0" key={st}>
              <Input
                id={`sv-status-${st}`}
                type="checkbox"
                checked={selectedStatuses.includes(st)}
                onChange={(e) => onToggleStatus(st, e.target.checked)}
              />
              <Label check for={`sv-status-${st}`} className="mb-0">
                {EnquirySiteVisitStatusMap[st]?.label ?? st}
              </Label>
            </FormGroup>
          ))}
        </div>
      </div>

      <Row className="g-2 g-md-3 align-items-end mb-0">
        <Col xs={12} sm={6} className="min-w-0">
          <Label className="form-label text-muted small mb-1">Enquiry</Label>
          <AsyncPaginatedSelect<EnquirySelectOption>
            components={{
              Option: EnquiryOption,
              SingleValue: EnquirySingleValue,
            }}
            fetchOptions={getEnquiryOptions}
            placeholder="Search enquiries…"
            value={enquiryId}
            onChange={(opt) =>
              onEnquiryIdChange(
                opt && !Array.isArray(opt)
                  ? Number((opt as EnquirySelectOption).value)
                  : null,
              )
            }
          />
        </Col>
        <Col xs={12} sm={6} className="min-w-0">
          <Label className="form-label text-muted small mb-1">Client</Label>
          <AsyncPaginatedSelect
            fetchOptions={getClientOptions}
            placeholder="Search client…"
            value={clientId}
            onChange={(opt) =>
              onClientIdChange(
                opt && !Array.isArray(opt)
                  ? Number((opt as SelectOption).value)
                  : null,
              )
            }
          />
        </Col>
      </Row>
    </div>
  );
}
